import './styles.css'
import '../Grid/styles.css'
import email from './images/email.svg'
import telefone from './images/telefone.svg'
import facebook from "./images/facebook.svg"
import instagram from "./images/instagram.svg" 
import linkedin from "./images/linkedin.svg"
import youtube from "./images/youtube.svg"
import whatsapp from "./images/whatsapp.svg"

export default function Contato() {


const versionStorage = localStorage.getItem('@ARP-appVersion');
const parsedVersionStorage = JSON.parse(versionStorage);
const versionStorageParsed = parsedVersionStorage.versionStorage;
const currentUrl = window.location.href;
const isStaging = currentUrl.includes('https://dev-portal.axsenergia.com.br/arp/') || currentUrl.includes('localhost');
const environmentLabel = isStaging ? 'STAGING' : 'PROD';

return (

    <>
     <div className="contatos">
      <div className="titleContatos">Contatos AXS Energia</div>
      <div className="gridContatos">
        <div className="retangulOContatoCinza">
        <div className='titleContato'>Comercial</div>
        <div className='textFuncionamento'>Funcionamento: 8h às 18h </div>
        <div className='textEmail'><a style={{color:'#212529'}} href="mailto:pim@axsenergia.com.br"><span className='imgRetangulo'><img src={email} alt={""}></img></span>pim@axsenergia.com.br</a></div>
        <div className='textTelefone'><a style={{color:'#212529'}} href="tel:+554831120679"><span className='imgRetangulo'><img src={telefone} alt={""}></img></span>(48) 3112-0679</a></div>
        </div>

        <div className="retangulOContatoCinza">
        <div className='titleContato'>Financeiro</div>
        <div className='textFuncionamento'>Funcionamento: 8h às 18h </div>
        <div className='textEmail'><a style={{color:'#212529'}}href="mailto:financeiro@axsenergia.com.br"><span className='imgRetangulo'><img src={email} alt={""}></img></span>financeiro@axsenergia.com.br</a></div>
        </div>

        <div className="retangulOContatoCinza">
        <div className='titleContato'>Pós-vendas</div>
        <div className='textFuncionamento'>Funcionamento: 8h às 18h </div>
        <div className='textEmail'><a style={{color:'#212529'}}href="mailto: atendimento@axsenergia.com.br"><span className='imgRetangulo'><img src={email} alt={""}></img></span>atendimento@axsenergia.com.br</a></div>
        <div className='textTelefone'><a style={{color:'#212529'}}href="tel:08007003434"><span className='imgRetangulo'><img src={telefone} alt={""}></img></span>0800 700 3434</a></div>
        <div className='textWhatsapp'><a style={{color:'#212529'}}href="https://wa.me/553171789156" target="_blank" rel="noreferrer noopener"><span className='imgRetangulo'><img src={whatsapp} alt={""}></img></span>Enviar mensagem</a></div>
        </div>

        <div className="retangulOContatoBranco">
        <div className='titleContatoBranco'>Acesse nossas redes sociais</div>
          <div className='gridRedes'>
            <a href='https://www.linkedin.com/company/axs-energia/' target="_blank" rel="noreferrer noopener"><img alt={""} src={linkedin}></img></a>
            <a href='https://www.youtube.com/@AXSEnergia' target="_blank" rel="noreferrer noopener"><img alt={""} src={youtube}></img></a>
            <a href='https://web.facebook.com/axsenergia' target="_blank" rel="noreferrer noopener"><img alt={""} src={facebook}></img></a>
            <a href='https://www.instagram.com/axsenergia/' target="_blank" rel="noreferrer noopener"><img alt={""} src={instagram}></img></a>
          </div>
        </div>
        <div className="textDados">VERSÃO AXS WEB ARP | {versionStorageParsed} - {environmentLabel}</div>
      </div>
    </div>
    </>  
  );
}